import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AirconUnit } from '@brokerportal/common/models/application';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class PortalActionsService {
    constructor(private httpClient: HttpClient) {}

    confirmInstallationAddress(
        applicationGuid: string,
        data: {
            firstName: string;
            lastName: string;
            installationAddress: string;
        }
    ) {
        return this.httpClient.post(
            `${environment.api.baseUrl}/portal/actions/confirmInstallationAddress/${applicationGuid}`,
            data
        );
    }

    confirmSystemDetails(
        applicationGuid: string,
        data: {
            systemType: string;
            batteryExternalId?: string;
            batteryQuantity?: number;
            batteryCapacity?: number;
            batterySerialNumber?: string;
            bessNumber?: string;
            nmi?: string;
            solarPanelExternalId?: string;
            solarPanelQuantity?: number;
            solarPanelCapacity?: number;
            inverterExternalId?: string;
            inverterSerialNumber?: string;
            hasExistingInverter: boolean;
            batteryCheckCode?: string;
            heatPumpModel?: string;
            heatPumpManufacturer?: string;
            evChargerModel?: string;
            evChargerManufacturer?: string;
            solarHotWaterModel?: string;
            solarHotWaterManufacturer?: string;
            airconModel?: string;
            airconManufacturer?: string;
            smartMeterModel?: string;
            smartMeterManufacturer?: string;
            poolPumpModel?: string;
            poolPumpManufacturer?: string;
            energyMonitoringSystemModel?: string;
            energyMonitoringSystemManufacturer?: string;
            inductionCooktopModel?: string;
            inductionCooktopManufacturer?: string;
            insulationBrand?: string;
            insulationModelNumber?: string;
            insulationRValueWallAndFloor?: string;
            insulationRValueCeiling?: string;
            nathersAssessmentPerformed?: boolean;
            airconUnits?: AirconUnit[];
        }
    ) {
        return this.httpClient.post(
            `${environment.api.baseUrl}/portal/actions/confirmSystemDetails/${applicationGuid}`,
            data
        );
    }

    updateTermType(applicationGuid: string, termType: string): Observable<void> {
        return this.httpClient.post<void>(
            `${environment.api.baseUrl}/portal/actions/updateLoanTermType/${applicationGuid}`,
            { termType },
            { headers: { 'Content-Type': 'application/json' } }
        );
    }
}
